const CarrierRelationsQueuesRoute = {
  path: '/carrier/queues',
  load: () => import('./CarrierRelationsQueues'),
  protected: true,
};

export { CarrierRelationsQueuesRoute };
